import { Injectable, NgModule } from '@angular/core';
@NgModule({})
@Injectable({
	providedIn: 'root'
})
export class ProcessingTotalsFilterService {

	private defaultFilterOption;

	constructor() { }

	public setFilter(filterName) {
		if (filterName === 'All Merchants') {
			this.defaultFilterOption = 0;
		} else if (filterName === 'Active Merchants') {
			this.defaultFilterOption = 1;
		} else if (filterName === 'Inactive Merchants') {
			this.defaultFilterOption = 2;
		} else if (filterName === 'Closed Merchants') {
			this.defaultFilterOption = 3;
		} else if (filterName === 'Sales Volume') {
			this.defaultFilterOption = 4;
		} else if (filterName === 'Transactions') {
			this.defaultFilterOption = 5;
		}
	}

	public getFilter() {
		if (this.defaultFilterOption > 0) {
			return this.defaultFilterOption;
		} else {
			return 0;
		}
	}
}
